import React from 'react';
import UtilityService from '../../../services/UtilityService';
import CartTotalSummaryItem from '../../content/CartTotalSummaryItem';
import { UIConstants } from '../../../utils/constants';

export const CartTotalSummaryTestId = 'carttotalsummary-summary';

export type CartTotalSummaryProps = {
  currencySymbol: string;
  discountTotal?: number;
  subTotal: number;
  shippingTotal?: number;
  taxTotal?: number;
  grandTotal: number;
  giftCardAmountUsed?: number;
  giftCards?: number;
};

const CartTotalSummary: React.FC<CartTotalSummaryProps> = ({
  currencySymbol,
  discountTotal,
  subTotal,
  shippingTotal,
  taxTotal,
  grandTotal,
  giftCardAmountUsed = 0,
  giftCards = 0,
}: CartTotalSummaryProps) => {
  const formatAmount = (amount?: number, additionalCost?: number): string => {
    if (amount === undefined) {
      return UIConstants.CALCULATED_AT_PAYMENT;
    }
    return UtilityService.formatAmount(amount, currencySymbol, additionalCost);
  };
  return (
    <div
      className="portrait:text-sm text-base md:mx-2 md:mt-8 pr-1 md:pr-0.5 portrait:max-h-screen-10 sm:max-h-screen-40 md:max-h-screen-50 overflow-y-auto"
      data-testid={CartTotalSummaryTestId}
    >
      {!!discountTotal && (
        <CartTotalSummaryItem
          formattedAmount={formatAmount(discountTotal)}
          className="md:mb-2"
        >
          Discounts
        </CartTotalSummaryItem>
      )}
      <CartTotalSummaryItem
        formattedAmount={formatAmount(subTotal)}
        className="md:mb-2"
      >
        Subtotal
      </CartTotalSummaryItem>
      {shippingTotal === undefined && taxTotal === undefined ? (
        <CartTotalSummaryItem
          formattedAmount={formatAmount()}
          className="mb-2 md:mb-4"
        >
          Shipping &amp; Tax
        </CartTotalSummaryItem>
      ) : (
        <>
          <CartTotalSummaryItem
            formattedAmount={formatAmount(shippingTotal)}
            className="md:mb-2"
          >
            Shipping
          </CartTotalSummaryItem>
          <CartTotalSummaryItem
            formattedAmount={formatAmount(taxTotal)}
            className="mb-2 md:mb-4"
          >
            Estimated Tax
          </CartTotalSummaryItem>
        </>
      )}
      {giftCardAmountUsed > 0 && (
        <CartTotalSummaryItem
          formattedAmount={formatAmount(giftCardAmountUsed)}
          className="md:mb-2"
        >
          Store Credit
        </CartTotalSummaryItem>
      )}
      {giftCards > 0 && (
        <CartTotalSummaryItem
          formattedAmount={formatAmount(-1 * giftCards)}
          className="md:mb-2"
        >
          Gift Card
        </CartTotalSummaryItem>
      )}
      <CartTotalSummaryItem
        bold
        className="md:pt-2 text-lg"
        formattedAmount={formatAmount(grandTotal)}
      >
        Total
      </CartTotalSummaryItem>
    </div>
  );
};

export default CartTotalSummary;
